import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router'
import { AnalyticsService } from '@sc/pas-common';
import { ClaimService } from './components/claim/claim.service';
import { ApiHelper } from '@sc/pas-common';
import { Observable } from 'rxjs';
import { HomeService } from '@sc/pas-common';
import { DownloadService } from '@sc/pas-common';
import { HomeUrlHelper } from '@sc/pas-common';
import { ListSetService } from 'app/core/services/list-set.service';
import { ProducerService } from '@sc/pas-common';
import { environment } from 'environments/environment';
import { AuthService } from '@sc/pas-common';
import { NotificationService } from './components/shared/notification/notification.service';
import { SupportedBrowsersService } from './components/supported-browsers-modal/supported-browsers.service';
import { AsyncSubject } from 'rxjs';
import { AuthGuardService } from '@sc/pas-common';
import { switchMap } from 'rxjs/operators';
import { isNumber } from 'util';
import { WindowRefService } from '@sc/pas-common';

@Component({
    selector: 'sc-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [AnalyticsService, ClaimService, DownloadService]
})
export class AppComponent implements OnInit {
    isScrolleable: boolean;
    routesScrolleables = ['/faq', '/protected-info', '/sign-up'];
    routesWithNoHeader = ['/poliza/', '/faq', '/forbidden', '/login', '/sign-up'];
    routesWithNoMenu = ['/poliza/', '/forbidden', '/login', '/sign-up', '/login-impersonificado', '/endosos'];
    public showHeader: boolean;
    public showLateralMenu: boolean;
    public url: any;
    public state: string;
    public showSBNotification: boolean;
    public SBTitle: any;
    public SBMessage: any;
    public SBAction: any;
    public showSB: boolean;
    public sbData: any;
    public claimLink: any;
    public selectedBranch: any = null;
    public loadingQuotation: boolean;
    public showBranchSelector: boolean;
    public showCategorySelector: boolean;
    public insuranceCoreName;
    public isMenuLateralOpen;
    public core;
    public branchItems;
    public userSettings: any;
    public hideSideBarMenu = true;
    public showCompleteMenu = true;
    public producers: any[];
    public isNotificationOpened: boolean;
    public displayCloseBar = false;
    public producersLoaded$: AsyncSubject<boolean>;
    public opportunityId: number;
    public categoryItems: any;
    public selectedCategory: any;

    @ViewChild('polizaLogs', { static: false }) polizaLogs: any;

    constructor(
        public authGuardService: AuthGuardService,
        private as: AnalyticsService,
        private claimService: ClaimService,
        private apiHelper: ApiHelper,
        private homeService: HomeService,
        private urlHelper: HomeUrlHelper,
        private router: Router,
        private listService: ListSetService,
        private producerService: ProducerService,
        private auth: AuthService,
        private notificationService: NotificationService,
        private windowRef: WindowRefService,
        private supportedBrowsersService: SupportedBrowsersService
    ) {
        this.isMenuLateralOpen = false;
        this.loadingQuotation = false;
        this.selectedBranch = null;
        this.onMessage().subscribe(message => this.handleOnMessage(message));
        const jwt = localStorage.getItem('tk');
        if (jwt) {
            this.setClaimLink();
            this.setUserSettings();
        }

        this.apiHelper
            .userObserver
            .subscribe((user: any) => {
                if (user && user.tk) {
                    this.initLateralDrawer();
                    this.setClaimLink();
                    this.setUserSettings();
                }
            });
        this.as.GTM.head(() => {});
        const SBOpened = localStorage.getItem('SBopened');
        const isOpened = SBOpened === '1' || !SBOpened;

        this.state = isOpened ? 'opened' : 'closed';
        this.producersLoaded$ = new AsyncSubject();
    }

    initLateralDrawer() {
        this.isMenuLateralOpen = false;
        this.loadingQuotation = false;
        this.selectedBranch = null;
    }

    ngOnInit() {
        this.url = this.router && this.router.url;
        this.isScrolleable = this.routesScrolleables.indexOf(this.url) >= 0;
        this.showBranchSelector = true;
        this.loadCategorySelectorData();
    }

    loadCategorySelectorData() {
        this.listService.categorySelectorData().subscribe(categories => {
            this.categoryItems = categories;
        });
    }

    updateOpportunityQuotes() {
        const updateQuoteStatus$ = this.producerService.getProducerCodes()
        .pipe(switchMap(producerCodes => {
          return this.producerService.updateQuoteStatus(producerCodes)
        }));

        updateQuoteStatus$.subscribe();
    }

    setUserSettings() {
        this.homeService
            .getUserSettings()
            .subscribe((userSettings: any) => {
                localStorage.setItem('userSettings', userSettings && JSON.stringify(userSettings));
                this.userSettings = userSettings;

                const isSidebarVisible = this.routesWithNoMenu.indexOf(this.url) < 0 && this.userSettings['sidebar_Enabled'];
                this.setSidebarVisibility(isSidebarVisible);

                if (!this.isImpersonatedUser()) {
                    this.updateOpportunityQuotes();
                }
            });
    }

    isImpersonatedUser() {
        return this.authGuardService.user && Boolean(this.authGuardService.user.IsImpersonated);
    }

    goTo(e) {
        const page = e.item;
        const index = e.index;

        if (page.token) {
            index.token = page.token;
        }
        const url = this.urlHelper.urlByOrigin(page.link, page.origin);
        if (this.urlHelper.shouldBeRouted(page)) {
            if (page.route == 'legado') {
                this.router.navigate(['/' + page.route], { queryParams: index })
            } else {
                if (page.route === 'external_link') {
                    this.windowRef.nativeWindow.open(page.link);
                } else {
                    this.router.navigate(['/' + page.route])
                }
            }
        } else {
            this.urlHelper.addTokenUrlItem(url, page.tokenType)
                .subscribe(urlParsed => {
                    if (page.origin === 'CLAIM') {
                        this.urlHelper.urlItemMode(page.mode, this.claimLink);
                    } else {
                        this.urlHelper.urlItemMode(page.mode, urlParsed, page.categoryKey);
                    }
                });
        }
    }

    handleCategorySelected(selectedCategory) {
        this.selectedCategory = selectedCategory.row;

        this.branchSelectorGoTo(selectedCategory);
    }

    handleBranchSelected(selectedBranch) {
        this.selectedBranch = selectedBranch.row;
        this.showCategorySelector = this.selectedBranch.shouldShowCategorySelector;

        this.branchSelectorGoTo(selectedBranch);
    }

    branchSelectorGoTo(branchSelectedData) {
        branchSelectedData.row.selected = true;
        const index = { branchIndex: branchSelectedData.index };
        const rowData = branchSelectedData.row;

        const userSettings = JSON.parse(localStorage.getItem('userSettings'));

        if (rowData.tokenType === 'NUEVO_PORTAL_TOKEN' && rowData.text === 'Hogar') {
            const token = localStorage.getItem('tk');
            const homeUrl = (!branchSelectedData.homeParams) ? `${environment.server.web.combinedFamily}/#/auth?token=${token}` : branchSelectedData.homeParams;
            window.open(homeUrl, '_blank');
            this.closeLateralMenu();
            return;
        }

        if (userSettings && userSettings['pasSelector_Enabled'] || rowData.shouldShowPasSelector) {
            this.producersLoaded$.subscribe(
                () => {
                    if (this.producers.length === 1) {
                        this.handleOnPasClick(this.producers[0]);
                    }
                }
            );

            return;
        }

        this.closeLateralMenu();
        this.goTo({ index, item: branchSelectedData.row });
    }

    handleOnPasClick(producer) {
        let iframe;
        let iframePoliza;

        if (this.selectedBranch.mode === 'EMBEDDED' && this.selectedBranch.route) {
            this.producerService.persistData(producer);
            this.auth.persistData({ ...this.auth.currentSessionValue, branchOffice: Number(producer.branchOffice) });
            if (this.opportunityId) {
            this.router.navigate([this.selectedBranch.route],
                { state: { opportunityId: this.opportunityId } });
            } else {
                this.router.navigate([this.selectedBranch.route]);
            }
            this.opportunityId = null;
            this.closeLateralMenu();
            return;
        }
        // Creo que este codigo se deberia eliminar
        iframePoliza = document.getElementById('polizaLogs');
        iframe = iframePoliza && iframePoliza['contentWindow'];
        this.homeService.sendMsg(iframe, { producer: producer, newQuotation: true });
        this.loadingQuotation = true;
        this.selectedBranch = null;
    }

    returnToBranchSelector(event) {
        if (this.selectedCategory) {
            this.selectedCategory = null;
        } else {
            this.selectedBranch = null;
        }
    }

    toggleSB() {
        this.state = this.state === 'opened' ? 'closed' : 'opened';
    }

    setSidebarVisibility(isVisible?: boolean) {
        if (!isVisible) {
            isVisible = this.isSidebarEnabled();
        }
        this.showSB = isVisible;
    }

    isSidebarEnabled(): boolean {
        this.url = this.url || this.router.url;
        return this.routesWithNoMenu.indexOf(this.url) < 0 && this.authGuardService.isFeatureEnabled('sidebar_Enabled');
    }

    updateMenu(event) {
        if (event && event.notifierObserver) {
            event.notifierObserver.subscribe(t => {
                this.showSnackBar(t.title, t.message, t.action)
            });
        }
        this.hideSideBarMenu = event && event.shouldHideSideBarMenu && event.shouldHideSideBarMenu();
        this.showCompleteMenu = (event && event.shouldShowCompleteMenu) ? event.shouldShowCompleteMenu() : true;

        this.url = event.router && event.router.url;
        this.isScrolleable = this.routesScrolleables.indexOf(this.url) >= 0;
        if (this.url) {
            this.showHeader = this.routesWithNoHeader.indexOf(this.url) < 0;
            this.showLateralMenu = this.shouldShowLateralMenu(this.url);
            this.isMenuLateralOpen = false;
        } else {
            this.showHeader = false;
        }
        this.showSB = this.isSidebarEnabled();
    }

    shouldShowLateralMenu(url) {
        const routesWithLateralMenu = ['/home', '/legado', '/inicio', '/polizas/cotizaciones', '/admin-leads'];
        const baseUrl = url.split('?')[0];
        return (routesWithLateralMenu.indexOf(baseUrl) > -1);
    }

    showSnackBar(title: any, message: any, action: any) {
        this.SBTitle = title;
        this.SBMessage = message;
        this.SBAction = action;
        this.showSBNotification = true;
    }

    closeLateralMenu() {

        this.isMenuLateralOpen = false;
        this.selectedBranch = null;
        this.selectedCategory = null;
        window.parent.postMessage({ closeLateralMenu: true }, '*');
    }

    onMessage() {
        return new Observable(observer => {
            window.addEventListener('message', function (event) {
                if (typeof (event.data) !== 'undefined') {
                    observer.next(event.data);
                }
            })
        });
    }

    handleOnMessage(message) {
        if (message.hasOwnProperty('openSelector')) {
            this.isMenuLateralOpen = !!message.openSelector;
            this.showBranchSelector = true;
            this.producers = null;
            this.producerService.getByUserID(this.authGuardService.user).subscribe(producers => {
                this.producers = producers;
                this.producersLoaded$.next(true);
                this.producersLoaded$.complete();
            });
        }
        if (message.hasOwnProperty('quotingStarted')) {
            this.loadingQuotation = false;
            this.showBranchSelector = false;
            this.isMenuLateralOpen = false;
        }
        if (message.hasOwnProperty('insuranceCoreNameByUser')) {
            this.insuranceCoreName = message.insuranceCoreNameByUser;
            this.listService.branchSelectorData().subscribe((data: any) => {
                this.branchItems = data;

                if (message.hasOwnProperty('fromBanner')) {
                    this.opportunityId = isNumber(message.fromBanner) ? message.fromBanner : null;
                    this.handleBranchSelected({'index': data.findIndex(x=>x.id === 'selector_rama_accidentes_personales'), 'row' : data.find(x=>x.id === 'selector_rama_accidentes_personales')});
                }
                if ('goToCarLite' in message) {
                    this.handleBranchSelected({'index': data.findIndex(x=>x.id === 'selector_rama_automotor-lite'), 'row' : data.find(x=>x.id === 'selector_rama_automotor-lite')});
                }
                if ('homeParams' in message) {
                    this.handleBranchSelected({'index': data.findIndex(x=>x.id === 'selector_rama_hogar'), 'row' : data.find(x=>x.id === 'selector_rama_hogar'), 'homeParams': message.homeParams});
                }
                if ('integralParams' in message) {
                    this.opportunityId = message.integralParams;
                    this.handleBranchSelected({'index': data.findIndex(x=>x.id === 'selector_rama_integral_comercio'), 'row' : data.find(x=>x.id === 'selector_rama_integral_comercio')});
                }
            });
        }
        if(message.hasOwnProperty('openMenu'))
        {
            this.showLateralMenu = this.shouldShowLateralMenu(this.url);
        }
    }

    setClaimLink() {
        this.claimService
            .check()
            .subscribe(result => {
                this.claimLink = result && result.link;
            });
    }

    onHandleNotificationBellClick(isNotificationOpened: boolean) {
        this.isNotificationOpened = isNotificationOpened;
        if (!isNotificationOpened) {
            this.getUnseenNotificationsCount();
        }
    }

    onHandleCloseNotification() {
        this.isNotificationOpened = false;
        this.getUnseenNotificationsCount();
    }

    shouldDisplayUnsupportedBrowserAlert() {
        return this.supportedBrowsersService.shouldDisplayAlert();
    }

    closeUnsupportedBrowserAlert() {
        this.supportedBrowsersService.isUnsupportedBrowserAlertClosed = true;
    }

    private getUnseenNotificationsCount() {
        this.notificationService.putMarkSeenNotifications(1).subscribe(
            () => {
                this.notificationService.getUnseenNotificationsCount();
            }
        );
    }

}
